import { render } from "./QwColorPicker.vue?vue&type=template&id=5308e9d3"
import script from "./QwColorPicker.vue?vue&type=script&lang=js"
export * from "./QwColorPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__